import { hasSecurityPackage } from '@adjust/dashboard-core/lib/utils/account';

import { getDateTimeByOffset } from '@lib/utils/dateTime';
import { connectWithStore } from '@react/Common/connectWithStore';
import { currencies } from '@react/constants/currencies';
import { getCurrentAccount, getCurrentUser } from '@redux/ducks/global';
import { fetchAccountData } from '@redux/ducks/accountData';
import { fetchData as fetchInvoces, getInvoices } from '@redux/ducks/invoices';
import { getPaymentMethod } from '@redux/ducks/paymentMethods';
import { getTwoFactorConfigurationState } from '@redux/ducks/twoFactorConfiguration';
import { getHistoryEventsState } from '@redux/ducks/historyEvents';
import { fetchUsers, getRolesCount, getUsersCount, selectIsLoading } from '@redux/ducks/users';
import {
  getPartnerAdAccountsState,
  fetchPartnerAdAccountsCounts,
} from '@redux/ducks/partnerAdAccounts/partnerAdAccounts';
import { AccountDataPage, AccountDataPageDispatchProps, AccountDataPageStateProps } from './AccountDataPage';

const mapStateToProps = (state): AccountDataPageStateProps => {
  const { invoices, currentCharge, isFetching: isChargeDataLoading } = getInvoices(state);
  const { paymentMethod, isLoadingPaymentMethod } = getPaymentMethod(state);
  const { config, isLoading: isTwoFactorLoading } = getTwoFactorConfigurationState(state);
  const { isLoading: isEventsLoading, events } = getHistoryEventsState(state);
  const currentAccount = getCurrentAccount(state);
  const currentUser = getCurrentUser(state);
  const { isLoading: isPartnerAdAccountsLoading, counts: partnerAdAccountsCount } = getPartnerAdAccountsState(state);
  const accountDatetime = currentAccount ? getDateTimeByOffset(currentAccount.timezone.utc_offset) : null;
  const userDatetime = currentUser?.timezone ? getDateTimeByOffset(currentUser.timezone.utc_offset) : accountDatetime;

  return {
    currentAccount,
    currentUser,
    currentCharge,
    isChargeDataLoading,
    invoices,
    paymentMethod,
    isLoadingPaymentMethod,
    twoFactorConfigurationEnabled: Boolean(config?.enabled),
    events,
    isEventsLoading,
    currency: currencies[currentAccount?.currency_iso_code || 'EUR'],
    hasSecurityPackage: hasSecurityPackage(currentAccount),
    rolesCount: getRolesCount(state),
    totalUsers: getUsersCount(state),
    isUsersLoading: selectIsLoading(state),
    partnerAdAccountsCount,
    isPartnerAdAccountsLoading,
    accountDatetime,
    userDatetime,
    isTwoFactorLoading,
  };
};

const mapDispatchToProps: AccountDataPageDispatchProps = {
  fetchAccountData,
  fetchUsers,
  fetchPartnerAdAccountsCounts,
  fetchInvoces,
};

export const AccountDataPageContainer = connectWithStore(mapStateToProps, mapDispatchToProps)(AccountDataPage);
